import { useState, FC } from "react";
import { GridSelectorModalWindow } from "../../../components/modalWindows/GridSelectorModalWindow";
import { v4 as uuidv4 } from 'uuid';
import { IEntitySimpleDTO } from "../../../libs/coreapi-dto/@types/common";
import { DocumentTypesPluginSettings } from "./DocumentTypesPluginSettings";
import { DocumentTypesGrid } from "./DocumentTypesGrid";

const DocumentTypesSelectorModal: FC<IGridSelectorModalProps> = (props) => {
    const [entity, setEntity] = useState<IEntitySimpleDTO>(props.selectedEntity ?? {} as IEntitySimpleDTO);
    const [entities, setEntities] = useState<IEntitySimpleDTO[]>(props.selectedEntities ?? []);
    const [disabled, setDisabled] = useState<boolean>(false);
    const gridId = uuidv4();
    const plugin = DocumentTypesPluginSettings;
    const checkMultipleSelect: boolean = props.multipleSelect ? (entities.length > 0 ? false : true) : (Object.keys(entity).length > 0 ? false : true);
    
    return (
        <GridSelectorModalWindow
            entityToPressEnter={entity}
            gridDisplayName={plugin?.name}
            ok={{
                onClick: () => props.multipleSelect ? props.ok(entities) : props.ok?.(entity),
                disabled: disabled || checkMultipleSelect
            }}
            cancel={{ onClick: () => props.cancel?.() }}
        >
            {
                plugin ? 
                    <DocumentTypesGrid 
                        data={entities}
                        gridId={gridId} 
                        plugin={plugin}
                        baseGridFilter={props.gridFilter}
                        multipleSelect={props.multipleSelect}
                        onSelect={(row, rowDto) => {
                            if (row && rowDto && rowDto.deleted === false) {
                                setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })
                                setDisabled(false)
                            } else if (row && rowDto && rowDto.deleted === true) {
                                setDisabled(true)
                            } else if (row) {
                                setDisabled(false)
                                setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })
                            } else {
                                setDisabled(true)
                                setEntity({ idGlobal: '', displayName: '' })
                            }
                        }}
                        onMultipleSelect={(rows) => {
                            if (rows.length > 0) {
                                setDisabled(false)
                                setEntities(rows.map(x => ({ idGlobal: x.idGlobal, displayName: x.displayName } as IEntitySimpleDTO)))
                            } else {
                                setDisabled(true)
                                setEntities([])
                            }
                        }}
                        onDoubleClick={(row) => {
                            setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })
                            props.ok?.(entity)
                        }}
                    />
                    : 
                    <p> {'Справочник не настроен'} </p>
            }
        </GridSelectorModalWindow>
    )
}

export default DocumentTypesSelectorModal